import React from "react";

const Privacy = () => {
  return (
    <section className="section">
      <div className="container" style={{ maxWidth: 720 }}>
        <p className="eyebrow">Legal</p>
        <h1>Privacy policy</h1>
        <h3>Who we are</h3>
        <p>Our website address is: https://raf9456.com</p>
        <h3>Embedded content from other websites</h3>
        <p>
          Articles on this site may include embedded content (e.g. videos, images,
          articles, etc.). Embedded content from other websites behaves in the exact
          same way as if the visitor has visited the other website.
        </p>
        <p>
          These websites may collect data about you, use cookies, embed additional
          third-party tracking, and monitor your interaction with that embedded
          content, including tracking your interaction with the embedded content if you
          have an account and are logged in to that website.
        </p>
      </div>
    </section>
  );
};

export default Privacy;
